import React, { useContext } from "react";

import { useAppSetting } from "@swa-ui/application";
import { PageFactory } from "@swa-ui/dotcom";
import {
  FlightDataContext,
  FlightTracker,
  FlightTrackerProvider,
  useAnalyticsData,
  WifiAuthenticationContext,
} from "@swa-ui/inflight";

import { MemberWifiStatusDetails } from "../../components/MemberWifiStatusDetails";

export const HomePage = () => {
  const { accountNumber, authType, firstName, lastName, preferredName, wifiAuthenticationState } =
    useContext(WifiAuthenticationContext);
  const flightData = useContext(FlightDataContext);
  const enableFlightTracker = useAppSetting("enableFlightTracker");

  useAnalyticsData({ accountNumber, authType, flightData, wifiAuthenticationState });

  return (
    <>
      {enableFlightTracker && (
        <FlightTrackerProvider>
          <FlightTracker />
        </FlightTrackerProvider>
      )}
      <PageFactory {...getPageFactoryProps()} />
    </>
  );

  function renderMemberWifiStatusDetails() {
    return <MemberWifiStatusDetails {...getMemberWifiStatusDetailsProps()} />;
  }

  function getPageFactoryProps() {
    return {
      componentRenderers: {
        MemberWifiStatusDetails: renderMemberWifiStatusDetails,
      },
      showBootstrap: false,
    };
  }

  function getMemberWifiStatusDetailsProps() {
    return {
      firstName,
      lastName,
      preferredName,
      wifiAuthenticationState,
    };
  }
};
